export default "__VITE_ASSET__b823b08f__"